import { Dices } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TRAIT_OPTIONS, randomTraits } from "@/lib/avatar";
import type { TraitSelection } from "@/types";

const categories: Array<keyof TraitSelection> = ["base", "eyes", "hair", "hairColor", "outfit", "accessory", "effect"];
const categoryLabel: Record<keyof TraitSelection, string> = { base: "Skin", eyes: "Eyes", hair: "Hair", hairColor: "Color", outfit: "Outfit", accessory: "Accessory", effect: "Effect" };

export function TraitBuilder({ traits, onChange }: { traits: TraitSelection; onChange: (traits: TraitSelection) => void }) {
  return (
    <section className="rounded-[24px] border border-white/10 bg-white/[.035] p-4 sm:p-5">
      <div className="mb-5 flex items-center justify-between gap-3">
        <div><p className="text-[11px] font-bold tracking-[0.2em] text-cyan-200/70">VISUAL DNA</p><h2 className="mt-1 text-lg font-bold">Shape the avatar</h2></div>
        <Button className="border-white/10 bg-white/5 hover:bg-white/10" onClick={() => onChange(randomTraits())} size="sm" variant="outline"><Dices className="size-4" />Randomize</Button>
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        {categories.map((category) => {
          const options = TRAIT_OPTIONS[category];
          return (
            <label className="space-y-1.5 text-sm" key={category}>
              <span className="text-xs font-medium text-white/55">{categoryLabel[category]}</span>
              <select
                className="h-10 w-full rounded-xl border border-white/10 bg-[#11131d] px-3 text-sm text-white outline-none transition focus:border-cyan-300/60"
                onChange={(event) => onChange({ ...traits, [category]: Number(event.target.value) })}
                value={traits[category]}
              >
                {options.map((option, index) => <option key={option} value={index}>{option}</option>)}
              </select>
            </label>
          );
        })}
      </div>
      <p className="mt-4 text-xs leading-5 text-white/35">The seven selected IDs form a permanent hash. Once minted, this exact combination can never mint again.</p>
    </section>
  );
}
